<template>
  <div id="dashboard">
    <div class="dashbar">
      <div class="column">
        <i class="fas fa-file-invoice dash-icon" @click="updateURL(0)"></i>
        <i class="fas fa-wallet dash-icon" @click="updateURL(1)"></i>
        <i class="fas fa-address-book dash-icon" @click="updateURL(2)"></i>
        <i class="fas fa-chart-line dash-icon" @click="updateURL(3)"></i>
        <i class="fas fa-stopwatch dash-icon" @click="updateURL(4)"></i>
      </div>
      <div class="column">
        <i class="fas fa-ellipsis-h dash-icon"></i>
      </div>
    </div>
    <div class="main">
      <keep-alive>
        <InvoiceDashboard v-if="selected == 0"></InvoiceDashboard>
      </keep-alive>
      <keep-alive>
        <ClientsDashboard v-if="selected == 2"></ClientsDashboard>
      </keep-alive>
      <keep-alive>
        <ProjectsDashboard v-if="selected == 4"></ProjectsDashboard>
      </keep-alive>
      <button @click="logout">Logout</button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import InvoiceDashboard from "../components/InvoiceDashboard";
import ClientsDashboard from "../components/ClientDashboard";
import ProjectsDashboard from "../components/ProjectsDashboard";

export default {
  name: "Dashboard",
  data() {
    return {
      selected: 0,
    };
  },
  methods: {
    logout: function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/");
        });
    },
    updateURL: function (x) {
      this.selected = x;
      if (this.selected == 0 && this.$route.query.type != "invoices") {
        this.$router.push("/dashboard?type=invoices");
      } else if (this.selected == 1 && this.$route.query.type != "payments") {
        this.$router.push("/dashboard?type=payments");
      } else if (this.selected == 2 && this.$route.query.type != "clients") {
        this.$router.push("/dashboard?type=clients");
      } else if (this.selected == 3 && this.$route.query.type != "analytics") {
        this.$router.push("/dashboard?type=analytics");
      } else if (this.selected == 4 && this.$route.query.type != "projects") {
        this.$router.push("/dashboard?type=projects");
      }
    },
  },
  watch: {
    $route(to) {
      if (to.query.type == "invoices") {
        this.selected = 0;
      } else if (to.query.type == "payments") {
        this.selected = 1;
      } else if (to.query.type == "clients") {
        this.selected = 2;
      } else if (to.query.type == "analytics") {
        this.selected = 3;
      } else if (to.query.type == "projects") {
        this.selected = 4;
      }
    },
  },
  created: function () {
    if (this.$route.query.type == "invoices") {
      this.selected = 0;
    } else if (this.$route.query.type == "payments") {
      this.selected = 1;
    } else if (this.$route.query.type == "clients") {
      this.selected = 2;
    } else if (this.$route.query.type == "analytics") {
      this.selected = 3;
    } else if (this.$route.query.type == "projects") {
      this.selected = 4;
    }
  },
  components: {
    InvoiceDashboard,
    ClientsDashboard,
    ProjectsDashboard,
  },
};
</script>

<style lang="scss" scoped>
#dashboard {
  display: flex;
  background: #ebecf0;

  .dashbar {
    width: 100px;
    height: 100vh;
    background: #2b303a;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .dash-icon {
      color: #ffffff;
      font-size: 1.4rem;
      margin: 15px 0;
      padding: 10px 0;
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        color: #0cce6b;
      }
    }
  }

  .main {
    padding: 15px;
    width: 100%;
  }
}
</style>